import {
  useEffect,
  useState,
} from 'react';

import { Link } from 'react-router-dom';

import serviciosData from '../../data/Serviciosdata';
import { useIdioma } from '../../context/IdiomaContext';

import './Servicios.css';

function Servicios() {
  const { idioma, t } = useIdioma();

  const [
    servicioSeleccionado,
    setServicioSeleccionado,
  ] = useState(null);

  const [
    opcionAbierta,
    setOpcionAbierta,
  ] = useState(null);

  const obtenerTextoTraducido = (contenido) => {
    if (
      typeof contenido === 'object' &&
      contenido !== null
    ) {
      return (
        contenido[idioma] ||
        contenido.es ||
        ''
      );
    }

    return contenido;
  };

  const abrirPanel = (servicio) => {
    setServicioSeleccionado(servicio);
    setOpcionAbierta(null);
  };

  const cerrarPanel = () => {
    setServicioSeleccionado(null);
    setOpcionAbierta(null);
  };

  const alternarOpcion = (opcionId) => {
    setOpcionAbierta((opcionActual) =>
      opcionActual === opcionId
        ? null
        : opcionId
    );
  };

  useEffect(() => {
    if (!servicioSeleccionado) {
      return undefined;
    }

    const cerrarConEscape = (event) => {
      if (event.key === 'Escape') {
        setServicioSeleccionado(null);
        setOpcionAbierta(null);
      }
    };

    document.body.style.overflow = 'hidden';

    window.addEventListener(
      'keydown',
      cerrarConEscape
    );

    return () => {
      document.body.style.overflow = '';

      window.removeEventListener(
        'keydown',
        cerrarConEscape
      );
    };
  }, [servicioSeleccionado]);

  return (
    <section className="pagina-servicios">
      <header className="servicios-encabezado">
        <p>
          {t('serviciosPagina.etiqueta')}
        </p>

        <h1>
          {t('serviciosPagina.titulo')}
        </h1>
      </header>

      <div className="servicios-lista">
        {serviciosData.map((servicio) => (
          <article
            id={servicio.id}
            className="servicio-detalle"
            key={servicio.id}
          >
            <div className="servicio-imagen">
              <img
                src={servicio.imagen}
                alt={obtenerTextoTraducido(
                  servicio.titulo
                )}
              />
            </div>

            <div className="servicio-contenido">
              <h2>
                {obtenerTextoTraducido(
                  servicio.titulo
                )}
              </h2>

              <p>
                {obtenerTextoTraducido(
                  servicio.resumen
                )}
              </p>

              <button
                type="button"
                className="solicitar-informacion"
                onClick={() =>
                  abrirPanel(servicio)
                }
              >
                {t(
                  'serviciosPagina.verOpciones'
                )}{' '}
                →
              </button>
            </div>
          </article>
        ))}
      </div>

      <div
        className={`panel-fondo ${
          servicioSeleccionado
            ? 'panel-fondo-visible'
            : ''
        }`}
        onClick={cerrarPanel}
        aria-hidden="true"
      />

      <aside
        className={`servicio-panel ${
          servicioSeleccionado
            ? 'servicio-panel-visible'
            : ''
        }`}
        aria-hidden={!servicioSeleccionado}
      >
        {servicioSeleccionado && (
          <>
            <button
              type="button"
              className="cerrar-panel"
              onClick={cerrarPanel}
              aria-label={t(
                'serviciosPagina.cerrar'
              )}
            >
              ×
            </button>

            <div className="panel-imagen">
              <img
                src={
                  servicioSeleccionado.imagen
                }
                alt=""
              />
            </div>

            <div className="panel-contenido">
              <p className="panel-etiqueta">
                {t(
                  'serviciosPagina.servicio'
                )}
              </p>

              <h2>
                {obtenerTextoTraducido(
                  servicioSeleccionado.titulo
                )}
              </h2>

              <p>
                {obtenerTextoTraducido(
                  servicioSeleccionado.descripcion
                )}
              </p>

              <h3>
                {t('serviciosPagina.planes')}
              </h3>

              <div className="opciones-servicio">
                {servicioSeleccionado.opciones.map(
                  (opcion, index) => {
                    const estaAbierta =
                      opcionAbierta ===
                      opcion.id;

                    return (
                      <article
                        className={`opcion-servicio ${
                          estaAbierta
                            ? 'opcion-servicio-abierta'
                            : ''
                        }`}
                        key={opcion.id}
                      >
                        <button
                          type="button"
                          className="opcion-cabecera"
                          onClick={() =>
                            alternarOpcion(
                              opcion.id
                            )
                          }
                          aria-expanded={
                            estaAbierta
                          }
                        >
                          <span className="opcion-numero">
                            {String(
                              index + 1
                            ).padStart(2, '0')}
                          </span>

                          <span className="opcion-titulo">
                            {obtenerTextoTraducido(
                              opcion.titulo
                            )}
                          </span>

                          <span
                            className="opcion-icono"
                            aria-hidden="true"
                          >
                            {estaAbierta
                              ? '−'
                              : '+'}
                          </span>
                        </button>

                        <div className="opcion-contenido">
                          <div>
                            <p className="opcion-subtitulo">
                              {obtenerTextoTraducido(
                                opcion.subtitulo
                              )}
                            </p>

                            <p>
                              {obtenerTextoTraducido(
                                opcion.descripcion
                              )}
                            </p>

                            <p>
                              <strong>
                                {t(
                                  'serviciosPagina.paraQuien'
                                )}
                                :
                              </strong>{' '}
                              {obtenerTextoTraducido(
                                opcion.dirigidoA
                              )}
                            </p>

                            <p>
                              <strong>
                                {t(
                                  'serviciosPagina.formato'
                                )}
                                :
                              </strong>{' '}
                              {obtenerTextoTraducido(
                                opcion.formato
                              )}
                            </p>

                            <Link
                              to={`/contacto?servicio=${servicioSeleccionado.id}&opcion=${opcion.id}`}
                              className="opcion-contacto"
                              onClick={
                                cerrarPanel
                              }
                            >
                              {t(
                                'serviciosPagina.solicitarInformacion'
                              )}
                            </Link>
                          </div>
                        </div>
                      </article>
                    );
                  }
                )}
              </div>
            </div>
          </>
        )}
      </aside>
    </section>
  );
}

export default Servicios;